export function menuSectionSlider() {

    //init slider
    const $slider = $(".menu-section .menu-gallery");
    const $settings = {
        arrows: false,
        infinite: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1
    };
    
    $slider.slick($settings);
}


// WEBPACK FOOTER //
// ./assets/js/modules/menu-section-slider.js